import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, FormControlLabel } from '@mui/material';
import { AppFormLayout, AppSelect, AppTextStyle, ImplicitSubmit } from '@shared';
import BasicTextField from '@shared/BasicTextField';
import { ta } from 'utils';

const propTypes = {
  formProps: PropTypes.object, // From polaris form provider
  users: PropTypes.array.isRequired,
}

const defaultProps = {

}

const TeamForm = (props) => {
  const { formProps, users } = props;
  return (
    <form onSubmit={formProps.handleSubmit}>
      <AppFormLayout>
        <hr />
        <BasicTextField
          name="name"
          label={ta("team.name")}
          {...formProps}
        />
        {/* <BasicTextField
          name="migration_handle"
          label={ta("team.migration_handle")}
          {...formProps}
        /> */}
        <AppFormLayout.Group condensed title="Tipo de mensajería (opcional)">
          <FormControlLabel
            label={ta("team.only_dispatch")}
            control={
              <Checkbox
                id="only_dispatch"
                checked={ !!formProps.values.only_dispatch }
                onChange={ (event) => formProps.handleChange(event.target.checked, "only_dispatch") }
              />
            }
          />
          <FormControlLabel
            label={ta("team.uber")}
            control={
              <Checkbox
                id="uber"
                checked={ !!formProps.values.uber }
                onChange={ (event) => formProps.handleChange(event.target.checked, "uber") }
              />
            }
          />
          <FormControlLabel
            label={ta("team.fruno")}
            control={
              <Checkbox
                id="fruno"
                checked={ !!formProps.values.fruno }
                onChange={ (event) => formProps.handleChange(event.target.checked, "fruno") }
              />
            }
          />
          <FormControlLabel
            label={ta("team.pickup")}
            control={
              <Checkbox
                id="pickup"
                checked={ !!formProps.values.pickup }
                onChange={ (event) => formProps.handleChange(event.target.checked, "pickup") }
              />
            }
          />
          <FormControlLabel
            label={ta("team.mail_americas")}
            control={
              <Checkbox
                id="mail_americas"
                checked={ !!formProps.values.mail_americas }
                onChange={ (event) => formProps.handleChange(event.target.checked, "mail_americas") }
              />
            }
          />
        </AppFormLayout.Group>
        <AppFormLayout.Group title="Otros valores">
          <FormControlLabel
            label={ta("team.disabled")}
            control={
              <Checkbox
                id="disabled"
                checked={ !!formProps.values.disabled }
                onChange={ (event) => formProps.handleChange(event.target.checked, "disabled") }
              />
            }
          />
        </AppFormLayout.Group>
        <AppTextStyle variation="subdued">Si desactiva el team, todos los mensajeros seran desactivados y sus ordenes desasignadas</AppTextStyle>
        <AppSelect
          id="user_id"
          name="user_id"
          label={ta("general.user")}
          options={ users }
          value={formProps.values.user_id}
          {...formProps}
          onChange={formProps.handleChangeNumber}
        />
      </AppFormLayout>

      <ImplicitSubmit />
    </form>
  )
};

TeamForm.propTypes = propTypes;
TeamForm.defaultProps = defaultProps;

export default TeamForm;